var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifi3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "14px",
    height: "12.905px",
    viewBox: "0 0 14 12.905",
    enableBackground: "new 0 0 14 12.905",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 0,
    fill: "#646464",
    width: 2,
    height: 12.905
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 3.539,
    fill: "#44B449",
    width: 2,
    height: 9.366
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7.078,
    fill: "#44B449",
    width: 2,
    height: 5.827
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 10.618,
    fill: "#44B449",
    width: 2,
    height: 2.288
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi3);
export default __webpack_public_path__ + "static/media/wifi_3.7b27b9b932da3734eb53eb54024ef4ab.svg";
export { ForwardRef as ReactComponent };